import debounce from 'lodash/debounce'
import { type FC, type HTMLAttributes, useEffect, useRef } from 'react'

type Props = {
  onResize: (height: number) => void
  debounceDelayMs?: number
} & HTMLAttributes<HTMLDivElement>

const ResizeObservedWrapper: FC<Props> = ({
  onResize,
  debounceDelayMs = 50,
  ...divProps
}) => {
  const contentRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (contentRef.current) {
      // Debounce prevents lots of rerenders
      const observer = new ResizeObserver(
        debounce((entries) => {
          onResize(entries[0].target.getBoundingClientRect().height)
        }, debounceDelayMs)
      )
      observer.observe(contentRef.current)
      return () => {
        observer.disconnect()
      }
    }
  }, [onResize])

  return <div ref={contentRef} {...divProps} />
}

export default ResizeObservedWrapper
